module.exports = __webpack_public_path__ + "img/img45.d0b92055.jpg";